import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["questionInput", "title"]

  connect() {
    this.sync()
  }

  sync() {
    const value = this.hasQuestionInputTarget ? this.questionInputTarget.value.trim() : ""
    this.titleTarget.textContent = value || "New FAQ"
  }
}
